export default __webpack_public_path__ + "static/media/wi-night-snow-wind.dfab9bf1.svg";